'use strict';

var departmentCtrl = ['$stateParams', '$uibModal', "dialog", 'Department', 'Member', '$state', '$translate', 'myTenant', 'myDepartments',
    function ($stateParams, $uibModal, dialog, Department, Member, $state, $translate, myTenant, myDepartments) {
        var _this = this;

        // TENANT VOOLKS CERTIFICATIONS
        this.myTenant = myTenant;
        _this.myTenant.load().then(() => {
            this.tenantId = _this.myTenant.get().id;
        })
        // this.voolksTenantId = "56fc21e402a3885f336d8d3f";
        // this.pampaTenantId = "60b0d8d8015d5f6b39cdbd57";
        // this.pampaEPTenantId = "5f159630815b7f852fbd1f6a";

        this.ownersChecked = {};
        this.selectAll = false;
        this.showButtonMultiUser = false;

        this.departmentTags = [];
        this.loadingSupervisor = true;

        this.department.owners.forEach((owner) => {
            this.ownersChecked[owner.id] = false;
        });

        this.toggleAllOwners = () => {
            this.department.owners.forEach((owner) => {
                this.ownersChecked[owner.id] = this.selectAll;
            });
            this.updateButtonVisibility();
        };

        this.cleanSelection = () => {
            this.selectAll = false;
            this.toggleAllOwners();
        }

        this.updateSelectAll = () => {
            this.selectAll = Object.values(this.ownersChecked).every((checked) => checked);
            this.updateButtonVisibility();
        };
        
        this.updateButtonVisibility = () => {
            this.showButton = Object.values(this.ownersChecked).some((checked) => checked);
        };

        this.removeUser = function (member) {
            dialog.confirm({
                title: $translate.instant('DASHBOARD.DASH_DEPT.ADMIN.DIAG_DEL.TITLE'),
                body: $translate.instant('DASHBOARD.DASH_DEPT.ADMIN.DIAG_DEL.BODY', { firstName: member.firstName, lastName: member.lastName }),
                accept: $translate.instant('DASHBOARD.DELETE'),
                cancel: $translate.instant('DASHBOARD.CANCEL'),
                size: 'sm'
            }).then(function () {
                Department.removeOwner({
                    departmentId: $stateParams.departmentId,
                    userId: member.id
                }, {})
                    .$promise
                    .then(function () {
                        if (_this.isSupervisor(member)) {
                            Member.unmakesupervisor({
                                userId: member.id
                            }).$promise
                                .then(function () {
                                    _this.supervisorsPerMemberIdLoad();
                                    _this.department.owners = _this.department.owners.filter(function (currentOwner) {
                                        return member.id !== currentOwner.id;
                                    });
                                    myDepartments.updateDepartmentOwners($stateParams.departmentId, _this.department.owners);
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        } else {
                            _this.department.owners = _this.department.owners.filter(function (currentOwner) {
                                return member.id !== currentOwner.id;
                            });
                            myDepartments.updateDepartmentOwners($stateParams.departmentId, _this.department.owners);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
        };

        this.multiTags = function () {
            const selectedUsers = this.department.owners.filter(owner => this.ownersChecked[owner.id]);
            this.addTags(_this.department, selectedUsers)
        }

        this.addTags = function (department, users) {
            $uibModal.open({
                animation: true,
                templateUrl: 'dashboard-department-admin/dashboardAddUserTagsModal.html',
                controller: [
                    "$uibModalInstance",
                    "BuilderDataService",
                    "toast",
                    "Department",
                    "department",
                    "users", 'Authentication', 'myDepartments',
                    function ($uibModalInstance, BuilderDataService, toast, Department, department, users, Authentication, myDepartments) {
                        var _this = this;
                        this.users = users;
                        this.department = department;

                        this.selectedTags = this.users.length > 1
                            ? this.users.reduce((commonTags, user) => {
                                return commonTags.filter(tag => 
                                    user.tags?.some(t => t.id === tag.id && t.departmentId === _this.department.id)); // common and department
                                }, this.users[0]?.tags?.filter(tag => tag.departmentId === _this.department.id) || [])
                                : [...(this.users[0]?.tags?.filter(tag => tag.departmentId === _this.department.id) || [])];

                        this.departmentTags = [];

                        this.getDepartmentTags = function () {
                            if (this.department.id) {
                                Department.tags({
                                    id: this.department.id,
                                })
                                    .$promise.then(function (data) {
                                        _this.departmentTags = data;
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });
                            } else {
                                console.log('NO HAY ID DEPTO')
                            }
                        }
                        this.close = function () {
                            // _this.user.tags = _this.selectedTags;
                            // let depts = JSON.parse(JSON.stringify(myDepartments.get()));
                            // depts.find(d => d.id == _this.department.id).owners.find(u => u.id == _this.user.id).tags = _this.selectedTags                             
                            // myDepartments.set(depts);
                            // console.log(myDepartments.get())
                            // $uibModalInstance.close(_this.department);
                            
                            this.users.forEach(user => {
                                user.tags = user.tags || [];
                                const newTags = _this.selectedTags.filter(tag => !user.tags.some(t => t.id === tag.id));
                                user.tags = [...user.tags, ...newTags];
                            });
                            let depts = JSON.parse(JSON.stringify(myDepartments.get()));
                            let department1 = depts.find(d => d.id === _this.department.id);
                            
                            this.users.forEach(user => {
                                const owner = department1.owners.find(owner => owner.id === user.id);
                                if (owner) {
                                    owner.tags = user.tags;
                                }
                            });

                            myDepartments.set(depts);
                            $uibModalInstance.close(_this.department);
                        };
                        this.getDepartmentTags();
                    },
                ],
                controllerAs: "modal",
                size: "md",
                windowClass: "dialog",
                bindToController: true, backdrop: 'static', keyboard: false,
                resolve: {
                    department: function () {
                        return department;
                    },
                    users: function () {
                        return users;
                    }
                }
            }).result.then((result) => {
                _this.department = result;
            });
        };

        _this.supervisorsPerMemberId = {};

        this.supervisorsPerMemberIdLoad = function () {
            // console.log('supervisorsPerMemberIdLoad')
            _this.loadingSupervisor = true;
            Member
                .find({
                    filter: {
                        include: ['roles']
                    }
                }, function (tmp_members) {
                    for (var i = 0; i < tmp_members.length; i++) {
                        var tmp_member = tmp_members[i];
                        var roles = tmp_member.roles;
                        var supervisor = roles.filter(function (role) {
                            return role.name === 'supervisor';
                        });
                        if (supervisor.length) {
                            _this.supervisorsPerMemberId[tmp_member.id] = true;
                        } else {
                            _this.supervisorsPerMemberId[tmp_member.id] = false;
                        }
                    }
                    _this.loadingSupervisor = false;
                }, function (error) {
                    console.log(error);
                    _this.loadingSupervisor = false;
                });
        };

        this.isSupervisor = function (member) {
            return _this.supervisorsPerMemberId[member.id];
        };

        this.getTagsToShow = (tags) => {
            let tagString = _this.getTagNames(tags) || '';
            if (tagString?.length > 20) {
                tagString = tagString.substring(0, 20) + '...';
            }
            return tagString;
        }

        this.getTagNames = function (tags) {
            if (tags && tags.length > 0) {
                return tags?.filter(function (tag) {
                    return tag.departmentId === _this.department.id;
                }.bind(this))
                    .sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    })
                    .map(function (tag) {
                        return tag.name;
                    })
                    .join(', ');
            } else {
                return '';
            }
        };

        this.customFilter = (member) => {
            if (_this.tagFilter) {
                let tagQuery = _this.tagFilter.toLowerCase();
                let tags = _this.getTagNames(member.tags); // Obtiene los tags como string
                return tags.toLowerCase().includes(tagQuery);
            }
            return true;
        };

        this.clearTagFilter = function() {
            _this.tagFilter = null;
            _this.customFilter();
        };

        this.selectTagSearch = (tag) => {
            // console.log('tag', tag);            
            _this.tagFilter = tag?.name || '';
        }

        this.selectTagSearch2 = () => {
            // console.log('this.tagFilter', this.tagFilter);
            // console.log('this.tagFilter2', this.tagFilter2);
            _this.tagFilter = this.tagFilter2?.name || '';
        }

        this.getDepartmentTags = function () {
            if (this.department.id) {
                Department.tags({
                    id: this.department.id,
                })
                    .$promise.then(function (data) {
                        _this.departmentTags = data;
                        // console.log('_this.departmentTags', _this.departmentTags)
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            } else {
                console.log('NO HAY ID DEPTO')
            }
        }

        _this.getDepartmentTags();

        _this.supervisorsPerMemberIdLoad();
    }];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            department: '=',
            reloadTable: '&',
        },
        controller: departmentCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-department-admin/dashboardDepartmentAdminDirective.html'
    };
};
